import React, { FunctionComponent } from 'react'
import TealToolTip from 'components/TealToolTip'

const TooltipWrapper: FunctionComponent<TooltipWrapperProps> = ({ condition, text, children, ...props }) => !condition ? children : (
  <TealToolTip arrow title={text} {...props}>
    {children}
  </TealToolTip>
)

interface TooltipWrapperProps {
  condition: boolean;
  text:string;
  children: React.ReactElement
}

export default TooltipWrapper
